import { artifactTypeUrl } from "@helpers/constants";

export const artifactTypePaths = Object.values(artifactTypeUrl)
  .concat("artifact")
  .join("|");
